import {
  ParkingLotOperationalStatusEnum,
  useParkingLotOperationalStatusEnumToText,
} from '@services/operation'
import { Select, SelectProps } from '@shared/Form/Select'
import { values } from 'ramda'

type Props = {
  isDesc?: boolean
  showAll?: boolean
} & SelectProps

export const ParkingLotOperationalStatusSelect = (props: Props) => {
  const toText = useParkingLotOperationalStatusEnumToText()

  return (
    <Select className="w-full" allowClear {...props}>
      {values(ParkingLotOperationalStatusEnum).map(status => (
        <Select.Option key={status} value={status}>
          {toText(status)}
        </Select.Option>
      ))}
    </Select>
  )
}

export default ParkingLotOperationalStatusSelect
